/**
 * appRelease.js — Re-export della versione applicativa.
 *
 * Da v1.10.1 (22/07/2026) la versione NON è più hardcoded qui.
 * L'unica fonte di verità è /app/frontend/src/config/release.json,
 * letto anche dal backend (services/gis_footer.py) e servito
 * dall'endpoint GET /api/meta/release. Per pubblicare una release,
 * modificare quel file JSON e nient'altro.
 *
 * Consumatori interni (immutati):
 *   - Login.js (footer istituzionale)
 *   - App.js (footer app-tech-footer)
 *   - printLayout.js (footer stampe HTML)
 *   - PrintFooter.jsx (footer preview React)
 *   - DesignSystemPage.jsx (banner Storybook)
 */
import releaseData from "./release.json";

export const APP_RELEASE = releaseData;
export default APP_RELEASE;

